export class Warning extends Error {}
